export const DEFAULT_LINE_WIDTH = 2;
export const DEFAULT_RADIUS = 4;

export const KEYPOINT_COLOR = "red";
export const SELECTED_KEYPOINT_COLOR = "lime";
export const DEFAULT_TRACE_COLOR = "cornflowerblue";
export const DEFAULT_SKELETON_COLOR = "white";

export const DEFAULT_VIDEO_SIZE = {width: 640, height: 480};

export const SKELETON_CONFIDENCE = 0.2;